export default {
    comparisonOptions: {
        leftType: "itemId",
        rightType: "constantValue",
        rightValue: "",
        operator: "equals"
    },
    conditionState: true,
    type: "trueValue",
    operator: "equals"
}